"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransformFromLocalizedField = exports.CDBaseEntity = exports.CDIndex = exports.CDRelationId = exports.CDJoinColumn = exports.CDManyToOne = exports.CDOneToOne = exports.CDUpdateDateColumn = exports.CDCreateDateColumn = exports.CDColumn = exports.CDPrimaryUUID = exports.CDObjectIdColumn = exports.CDPrimaryColumn = exports.CDEntity = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
let typeorm;
if (global.DEPLOYMENT_NODE === true) {
    // tslint:disable-next-line:no-var-requires
    typeorm = require("typeorm");
}
function CDEntity(...args) {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.Entity.apply(typeorm, args);
    }
    return () => { };
}
exports.CDEntity = CDEntity;
function CDPrimaryColumn(type, options) {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.PrimaryColumn(type, options);
    }
    return () => { };
}
exports.CDPrimaryColumn = CDPrimaryColumn;
function CDObjectIdColumn() {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.ObjectIdColumn();
    }
    return () => { };
}
exports.CDObjectIdColumn = CDObjectIdColumn;
function CDPrimaryUUID() {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.PrimaryGeneratedColumn("uuid");
    }
    return () => { };
}
exports.CDPrimaryUUID = CDPrimaryUUID;
function CDColumn(type, options) {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.Column(type, options);
    }
    return () => { };
}
exports.CDColumn = CDColumn;
function CDCreateDateColumn() {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.CreateDateColumn();
    }
    return () => { };
}
exports.CDCreateDateColumn = CDCreateDateColumn;
function CDUpdateDateColumn() {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.UpdateDateColumn();
    }
    return () => { };
}
exports.CDUpdateDateColumn = CDUpdateDateColumn;
function CDOneToOne(...args) {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.Column.apply(typeorm, args);
    }
    return () => { };
}
exports.CDOneToOne = CDOneToOne;
function CDManyToOne(...args) {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.ManyToOne.apply(typeorm, args);
    }
    return () => { };
}
exports.CDManyToOne = CDManyToOne;
function CDJoinColumn(...args) {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.JoinColumn.apply(typeorm, args);
    }
    return () => { };
}
exports.CDJoinColumn = CDJoinColumn;
function CDRelationId(...args) {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.RelationId.apply(typeorm, args);
    }
    return () => { };
}
exports.CDRelationId = CDRelationId;
function CDIndex(type, options) {
    if (global.DEPLOYMENT_NODE === true) {
        return typeorm.Index(type, options);
    }
    return () => { };
}
exports.CDIndex = CDIndex;
let CDBaseEntity;
// It looks so wrong
if (global.DEPLOYMENT_NODE === true) {
    exports.CDBaseEntity = CDBaseEntity = typeorm.BaseEntity;
}
else {
    exports.CDBaseEntity = CDBaseEntity = class {
    };
}
const getTransformFromLocalizedField = (localizeFieldName) => (_, obj) => {
    const localizedField = obj[localizeFieldName];
    return localizedField === undefined
        ? ""
        : localizedField[legacy_enums_1.Languages.en]
            ? localizedField[legacy_enums_1.Languages.en]
            : "";
};
exports.getTransformFromLocalizedField = getTransformFromLocalizedField;
//# sourceMappingURL=orm.js.map